import { Button } from "@/components/shared/buttons/Button";
import { Upload } from "@mui/icons-material";
import { useState } from "react";
import { BulkImportDialog } from "./dialogs/bulk-import-dialog/BulkImportDialog";

/**
 * TopicsImportButton component - Opens the bulk import dialog
 */
export const TopicsImportButton = () => {
    const [dialogOpen, setDialogOpen] = useState(false);

    return (
        <>
            <Button
                type="button"
                variant="contained"
                disableElevation
                sx={{ borderRadius: 22 }}
                startIcon={<Upload />}
                onClick={() => setDialogOpen(true)}
            >
                Import
            </Button>
            <BulkImportDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
            />
        </>
    );
};
